<div class="text-center s-p-3 border border-clr-platform-lightest">
  <img
    class="s-h-50"
    src="/assets/images/empty-48.svg"
    [alt]="'no-data-found' | transloco"
  />
  <h2 class="c-card-subtitle">
    {{ "no-data-found" | transloco }}
  </h2>
</div>
